export default __webpack_public_path__ + "static/media/rolling-stone.2a67ac0e.jpg";